



function parseDurationList(str){ if(!str) return [0]; return str.split(',').map(s=>s.trim()).map(v=>v.endsWith('ms')?parseFloat(v):v.endsWith('s')?parseFloat(v)*1000:(+v||0)); }
function getMaxAnimTime(el){
  const cs = getComputedStyle(el);
  const t = parseDurationList(cs.transitionDuration);
  const a = parseDurationList(cs.animationDuration);
  return Math.max(...t, ...a);
}
export function waitTransition(el){
  const ms = getMaxAnimTime(el);
  if(ms<=0) return Promise.resolve();
  return new Promise(res=>{
    let done=false;
    const finish=()=>{ if(done) return; done=true; cleanup(); res(); };
    const te=e=>{ if(e.target===el) finish(); };
    const ae=e=>{ if(e.target===el) finish(); };
    const cleanup=()=>{ el.removeEventListener('transitionend',te); el.removeEventListener('animationend',ae); clearTimeout(timer); };
    el.addEventListener('transitionend',te,{once:true});
    el.addEventListener('animationend',ae,{once:true});
    const timer=setTimeout(finish, ms+50);
  });
}


export function withHeightLock(container, task){
  const h = container.offsetHeight;
  container.style.height = h+'px';
  container.style.overflow='hidden';
  const end=()=>{ container.style.height=''; container.style.overflow=''; };
  try{
    const p=Promise.resolve().then(task);
    p.finally(end);
    return p;
  }catch(e){ end(); throw e; }
}


function endNow(el){ el.classList.add('is-hidden'); el.classList.remove('is-leaving'); }

export function fadeOut(el){
  if(!el || el.classList.contains('is-hidden')) return Promise.resolve();
  el.classList.add('is-leaving');
  if(getMaxAnimTime(el)<=0){ endNow(el); return Promise.resolve(); }
  return waitTransition(el).then(()=>{ endNow(el); });
}

export function fadeIn(el){
  if(!el) return Promise.resolve();
  el.classList.remove('is-hidden'); 
  
  
  el.offsetWidth;
  el.classList.remove('is-leaving');
  if(getMaxAnimTime(el)<=0) return Promise.resolve();
  return waitTransition(el);
}

export function toggleFade(el,on){ return on?fadeIn(el):fadeOut(el); }


function applyEnter(scope){
  scope.querySelectorAll('[data-ani-enter-show]').forEach(fadeIn);
  scope.querySelectorAll('[data-ani-exit-show]').forEach(fadeOut);
}
function applyExit(scope){
  scope.querySelectorAll('[data-ani-exit-show]').forEach(fadeIn);
  scope.querySelectorAll('[data-ani-enter-show]').forEach(fadeOut);
}

function initialSync(scope){
  const pref = scope.getAttribute('data-ani-initial');
  if (pref === 'enter') { applyEnter(scope); return; }
  if (pref === 'exit')  { applyExit(scope);  return; }
  
  if (scope.classList.contains('is-inview')) applyEnter(scope);
  else applyExit(scope);
}

export function initAniVisibilityAuto(){
  const onEnter = (e)=> applyEnter(e.target);
  const onExit  = (e)=> applyExit(e.target);

  document.addEventListener('ani:inview-enter', onEnter, true);
  document.addEventListener('ani:inview-exit',  onExit,  true);

  
requestAnimationFrame(() => {
  document
    .querySelectorAll('.ani-inview-scope, .ani-when-inview, [data-ani-inview]')
    .forEach(initialSync);
});

  return ()=> {
    document.removeEventListener('ani:inview-enter', onEnter, true);
    document.removeEventListener('ani:inview-exit',  onExit,  true);
  };
}






export function initDirectionalVisibilityGate(options = {}) {
  const cfg = {
    scopeSelector: '.ani-inview-scope[data-ani-sticky-enter]',
    blockDirection: 'down', 
    ...options,
  };

  let lastY = window.scrollY || 0;
  let dir = 'down';

  const onScroll = () => {
    const y = window.scrollY || 0;
    if (y > lastY) dir = 'down';
    else if (y < lastY) dir = 'up';
    lastY = y;
  };

  
  const onExit = (e) => {
    const scope = e.target;
    if (!(scope instanceof Element)) return;
    if (!scope.matches(cfg.scopeSelector)) return;
    if (dir === cfg.blockDirection) {
      
      e.stopImmediatePropagation();
      
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('ani:inview-exit', onExit, true); 

  
  onScroll();

  return () => {
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('ani:inview-exit', onExit, true);
  };
}